import React, { forwardRef } from "react";
import { Box } from "@mui/material";

// ----------------------------------------------------------------------

const Main = forwardRef<HTMLDivElement, any>(
  ({ children, sx, ...other }, ref) => {
    return (
      <Box
        ref={ref}
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          height: `calc(100% - 20px)`,
          maxHeight: `calc(100% - 20px)`,
          overflow: "auto",
          overflowX: "hidden",
          ...sx,
        }}
        {...other}
      >
        {children}
      </Box>
    );
  }
);

export default Main;
